import React from "react";
import Checkmark from '../includes/svg/checkmark-icon';
import PlusIcon from '../includes/svg/plus-icon';
import Button from '../includes/button';

const priceCard = {
    name: "ReadyPMO",
    price: "$15,000",
    description: "Everything you need for a professional PMO, delivered in 4–6 weeks.",
    includes: [
        "Project Intake & Prioritization Process",
        "PMO Operating Model & Governance Framework",
        "Standard Operating Procedures (SOPs)",
        "Comprehensive PM Template Library",
        "Communication & Stakeholder Strategy",
        "KPI & Reporting Toolkit",
        "PM Software Workspace Configuration",
        "Team Training & Onboarding Guide"
    ]
};

const addOns = [
    {
        title: "Partnered Advisory",
        description: "Ongoing weekly coaching, adoption support, and dashboard tuning for 3 months post implementation.",
    },
    {
        title: "Business Analysis",
        description: "Deep-dive team interviews, process mapping, bottleneck analysis, and PM Software workflows tailored to your organization.",
    }
]

const bookNowLink = "https://iupvv4w5jnf.typeform.com/to/yBkVq6mW";

const Pricing = () => {
    return (
        <div className="w-full flex flex-col gap-10 md:px-12 md:py-20 px-6 py-12 container mx-auto bg-white rounded-2xl xl:max-w-7xl">
            <h2 className="text-5xl font-normal text-blue10 text-center w-full">Pricing</h2>
            <div className="flex lg:flex-row flex-col justify-between items-center gap-16 lg:gap-12">
                <div className={"bg-primaryBrand w-full max-w-[420px] md:w-[420px] text-white10 p-10 rounded-3xl flex flex-col justify-start items-start gap-6"}>
                    <div className="w-full flex flex-col gap-6 justify-start text-left items-start">
                        <div className="flex flex-col gap-4 items-center justify-center text-center w-full">
                            <h2 className="text-2xl font-bold pointer-events-none">{priceCard.name}</h2>
                            <h3 className="text-3xl font-bold pointer-events-none">
                                {priceCard.price}
                            </h3>
                        </div>
                        <div className={"h-[1px] w-4/5 mx-auto bg-whiteGradientBorder"}></div>
                        <p className="text-base text-white10">{priceCard.description}</p>
                        <ul className="flex flex-col gap-6 text-left">
                            {priceCard.includes.map((include, index) => (
                                <li key={index} className="flex flex-row gap-4 items-center">
                                    <div className={"bg-white w-6 h-6 rounded-full aspect-square flex justify-center items-center"}>
                                        <Checkmark color={"#182553"} />
                                        </div>
                                    <p className={"text-white10 text-sm font-semibold pointer-events-none"}>{include}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="flex flex-col gap-5 w-full flex-1 items-center lg:items-start justify-center lg:justify-start">
                    <div className="flex flex-col gap-2 justify-start items-start">
                        <div className="flex flex-row gap-2 justify-start items-center">
                            <div className="w-6 h-6 rounded-full aspect-square flex justify-center items-center bg-primaryBrand">
                                <PlusIcon color={"#FFFFFF"} />
                            </div>
                            <h3 className="text-4xl font-normal tracking-tighter pointer-events-none">Add-Ons</h3>
                        </div>
                        <p className="text-2xl leading-relaxed font-semibold text-blue10 max-w-md text-left">Everything you need for a professional PMO, with optional Add-ons</p>
                    </div>
                    <hr className="w-full border-black20 border-solid" />
                    <ul className="flex flex-col gap-8 text-left">
                        {addOns.map((addOn, index) => (
                            <li key={index} className="flex flex-col gap-4 items-start justify-start bg-grey30 border border-lightBlue80 border-solid p-4 rounded-lg max-w-lg">
                                <h4 className={"text-blue10 lg:text-2xl text-xl font-bold pointer-events-none text-left"}>{addOn.title}</h4>
                                <p className={"text-blue10 lg:text-2xl text-xl font-normal pointer-events-none leading-loose text-left"}>{addOn.description}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="flex flex-col gap-6 md:gap-4 justify-center items-center text-center">
                <h3 className="lg:text-5xl md:text-3xl text-2xl font-normal leading-snug md:leading-snug lg:leading-snug pointer-events-none">Book a discovery Call Today</h3>
                <Button to={bookNowLink} label="Book Now" variant={"light-primary"} isHashLink={false} />
            </div>
        </div>
    );
}

export default Pricing;